import { PremiumSectionTopic } from "./premiumSectionTopic.model"
import { PremiumRelatedSection } from "./premiumRelatedSection.model"
import { Attribute } from "../attribute.model"
import { PremiumFooterSection } from "./premiumFooterSection.model"
import { ITSImage } from "../itsImage.model"
import ResourceUtils from "../../utils/resource-utils"
import { PremiumColors } from "./premiumColors.model"
// TODO can we somehow consolidate the two modals, from a business logic standpoint, there is not so much difference between the two, we could reflect that in code to be more readable
export class PremiumSectionPage {
    public constructor(
        public subcollectionId: string,
        public collectionId: string, //TODO:might be changed,
        public parentPublish: boolean = true,
        public loId: string,
        public title: string,
        public metaTitle: string,
        public description: string,
        public credits: string,
        public parentCollectionSlug: string,
        public parentCollectionTitle: string,
        public parentCollectionWhiteLogo: ITSImage,
        public parentCollectionColorLogo: ITSImage,
        public hero: ITSImage,
        public heroGradient: boolean,
        public whiteLogo: ITSImage,
        public colorLogo: ITSImage,
        public attributions: Attribute[],
        public topics: PremiumSectionTopic[],
        public relatedSections: PremiumRelatedSection[],
        public footerSection: PremiumFooterSection,
        public resourceGrades: string[],
        public resourceMediaTypes: { [mediaType: string]: number },
        public colors: PremiumColors,
        public brands: string[],
        public topLevelSubjects: string[],
        public contentProjects: string[],
        public resourcesByLanguage: { [language: string]: number },
        public subcollectionType: string
    ) {}

    public getAdminLink(): { url: string; title: string } {
        let ownURL = null
        if (this.subcollectionType === "custom") {
            ownURL = `/admin/cms/customsubcollection/${this.subcollectionId}/`
        } else if (this.subcollectionType === "curriculum_hierarchy") {
            ownURL = `/admin/cms/curriculumhierarchysubcollection/${this.subcollectionId}/`
        } else if (this.subcollectionType === "content_project") {
            ownURL = `/admin/cms/contentprojectsubcollection/${this.subcollectionId}/`
        }
        if (ownURL) {
            return { url: ownURL, title: "Sub-collection" }
        } else {
            return {
                url: `/admin/cms/collection/${this.collectionId}/`,
                title: "Collection",
            }
        }
    }

    public getFooterAttributions(): Attribute[] {
        // Hide business logic here for now.
        return this.attributions
    }

    public getResourceTypesDisplay(): string {
        return ResourceUtils.getResourceTypesDisplay(
            this.resourceMediaTypes,
            this.resourceGrades,
            this.resourcesByLanguage
        )
    }

    public static fromData(data): PremiumSectionPage {
        const relatedSections = [
            PremiumRelatedSection.fromData(data.related_first_section),
            PremiumRelatedSection.fromData(data.related_second_section),
        ].filter((section) => !!section)
        const topics = (data.topics || []).map((topic_data) =>
            PremiumSectionTopic.fromData(topic_data)
        )
        const resourceTypes = data.resources_info || {}
        return new PremiumSectionPage(
            data.id,
            data.collection_id,
            data.parent_publish,
            data.lo_id,
            data.title,
            data.display_meta_title || data.title,
            data.description,
            data.credits,
            data.parent_collection_slug,
            data.parent_title,
            new ITSImage(data.parent_white_logo, data.parent_white_logo_alt_text),
            new ITSImage(data.parent_color_logo, data.parent_color_logo_alt_text),
            new ITSImage(data.hero, data.hero_alt_text),
            data.hero_gradient,
            data.white_logo ? new ITSImage(data.white_logo, data.white_logo_alt_text) : null,
            data.color_logo ? new ITSImage(data.color_logo, data.color_logo_alt_text) : null,
            Attribute.fromDataArray(data.attributions || []),
            topics,
            relatedSections,
            data.footer_links ? PremiumFooterSection.fromData(data.footer_links) : null,
            resourceTypes.grades || [],
            resourceTypes.media_types || {},
            new PremiumColors(data.style_content),
            data.brands,
            data.top_level_subjects,
            data.content_projects,
            resourceTypes.resources_by_language,
            data.subcollection_type
        )
    }
}
